import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./pdfViewer.html";
import { eventTypes, fireEvent, registerListener, unregisterAllListeners } from 'util/pubsub';
// import { eventTypes, registerListener, unregisterAllListeners } from 'util/pubsub';
// import {track, LightningElement} from 'lwc';

import LightningElementSLDS from 'util/lightningElementSLDS';
import { isMobile, isHorizontal } from 'util/commonFunctions';
import { setApp, closeSidebar } from '../app/appUtil';
//import {loadPdfFromGoogle} from 'util/googleDrivePicker'
class pdfViewer extends LightningElementSLDS {
  constructor(...args) {
    super(...args);
    this.parentLoadsPdf = false;
    this.displayDEPanel = false;
    /*
        let parentDiv = this.template.querySelector((".data-entry-div");
        console.log({parentDiv});
        parentDiv.classList.remove('initial-hidden');
      */
    this.renderThumbnails = void 0;
    this.displayThumbnails = void 0;
    this.renderMobileToolbar = void 0;
    this.toolbarType = __g_toolbarType && "kb" !== __g_toolbarType;
    this.tParam = void 0;
    this.showThumbnails = true;
    this.displayToolbar = void 0;
    // This is needed by the pubsub code to assure that events are only sent between components on the same page. We
    // need to come up with some attribute(s) that we can use to mark the components as belonging to a certain page/application.
    this.pageRef = {
      attributes: {
        "developer": "zPaper",
        "application": "Document Viewer"
      }
    };
    /**
     * This variable is used to avoid loading view , data & attach toolbars
     */
    this.loadingDefaultPdf = false;
    /**
     * This variable will hold the url of the defualt pdf that we wand to load on PDF CLient Load
     */
    this.defaultPdfUrl = "";
    /**
     * This variable is used to store the pdf file body received from load_pdf event
     */
    this.pdfFile = void 0;
    this.fillOnLoad = void 0;
    this.selectedPersona = void 0;
    this.renderToolbarButton = void 0;
    this.isMobile = false;
    this.initialRenderDone = false;
  }
  //AHS - we have duplicated functions across parent and child 
  //need to create a separate util file for the common code
  parseHostFromUrl(protocol, url) {
    if (__g_protocol === 'file') {
      return 'file';
    }
    url = decodeURIComponent(url); // decode if necessary...
    let idxBegin = url.indexOf("://") > 0 ? url.indexOf("://") + 3 : 0;
    if (idxBegin === 0) {
      return __g_hostname; //SHR220113 handle local api/xxx calls
    }
    let idxEnd = url.indexOf('/', idxBegin);
    if (idxEnd < 0) {
      return url.substring(idxBegin);
    }
    return url.substring(idxBegin, idxEnd);
  }

  /**
   * This method will load the PDF and pass it on to the thumbnails and main pane component
   */
  initializeChildren(snippetId) {
    let self = this;
    // let pdfUrl = `api/viewForm?id=${snippetId}`;

    // if (__g_requestedPdf) {
    //     //using api server / kb server to retrieve the file
    //     pdfUrl = isApiServerAvailable ?  `api/no-zippi/getUrl?get=${__g_requestedPdf}` : `/kb/client/wget.jsp?get=${__g_requestedPdf}`;

    //     //load pdf file using the client instead of 
    //     let decodedPdfURL = decodeURIComponent(__g_requestedPdf);
    //     if(decodedPdfURL.indexOf("zippi/") > -1 && decodedPdfURL.indexOf("SFsession") > -1) {
    //         let decodedPdfURLParts = decodedPdfURL.split("?");
    //         let zippiUrl = decodedPdfURLParts[0];
    //         let zippiUrlParams = new URLSearchParams("?" + decodedPdfURLParts[1]);
    //         let recordId = zippiUrlParams.get("recordId");
    //         let sessionId = zippiUrlParams.get("SFsession");

    //         let zippiFormsEndpoint = "https://gw.zpaper.com" + zippiUrl.replace("kb/","") + '?recordId=' + recordId;//expecting the partial url before "?" e.g. kb/zippi/forms/PDF/00004ee8Z1g111u6ce

    //         fetch(zippiFormsEndpoint, {
    //             method: 'GET',
    //             headers: {
    //               'Accept': 'application/pdf',
    //               'Content-Type': 'application/json',
    //               'Authorization': 'Bearer ' + sessionId
    //             }
    //         }).then(res => res.arrayBuffer())
    //         .then(arrayBufferRes => {
    //             let event = new CustomEvent(eventTypes.PDF_LOADED, {detail: {doc: arrayBufferRes, success: true, loadingDefaultPdf: self.loadingDefaultPdf, fillOnLoad: this.fillOnLoad, selectedPersona: this.selectedPersona}, bubbles: true, cancelable: true});
    //             fireEvent(self.pageRef, eventTypes.PDF_LOADED, event);
    //         }).catch(formsError => {
    //             console.error("An error occured while fetching pdf from forms endpoint", formsError);
    //             let event = new CustomEvent(eventTypes.PDF_LOADED, {detail: {error: formsError, success: false}, bubbles: true, cancelable: true});
    //             fireEvent(self.pageRef, eventTypes.PDF_LOADED, event);
    //         });

    //         return;
    //     }

    //     let host = this.parseHostFromUrl(__g_protocol, __g_requestedPdf);
    //     console.log("Requested PDF host => " + host);
    //     console.log("Host that served up this UI => " + __g_hostname);

    //     if ('file' === host || host === __g_hostname) {
    //         // Just pull the url directly using AJAX if it is coming from the same host that served up this UI.
    //         // I don't think the local file will work because of cross-site protections, but we'll see.
    //         pdfUrl = decodeURIComponent(__g_requestedPdf);
    //     }
    // }

    //let pdfUrl = '/red/pc/view/PDF/' + getzItemId();
    let pdfUrl = __g_zApiURL + 'view/PDF/' + getzItemId();
    if (self.loadingDefaultPdf) {
      //pdfUrl = isApiServerAvailable ? `api/no-zippi/getUrl?get=${self.defaultPdfUrl}` : self.defaultPdfUrl;
      pdfUrl = __g_isApiServerAvailable ? __g_zApiURL + `fetch/getUrl?get=${self.defaultPdfUrl}` : self.defaultPdfUrl;
    }
    if (self.pdfFile) {
      pdfUrl = self.pdfFile;
      //self.pdfFile = null;
    }

    //alert("pdfViewer pdfUrl : " + pdfUrl);
    // let loadingTask = pdfjsLib.getDocument(pdfUrl, pdfHeaders);
    // let loadingTask = pdfjsLib.getDocument(pdfUrl);
    /* loadingTask.promise.then(function (doc) {
         doc.getData().then(result => {
             let event = new CustomEvent(eventTypes.PDF_LOADED, {detail: {doc: result, success: true, loadingDefaultPdf: self.loadingDefaultPdf, fillOnLoad: self.fillOnLoad, selectedPersona: self.selectedPersona}, bubbles: true, cancelable: true});
             fireEvent(self.pageRef, eventTypes.PDF_LOADED, event);
         });
     }).catch(loadError => {
         console.error("An error occured while zPDF (PV)", loadError);
         let event = new CustomEvent(eventTypes.PDF_LOADED, {detail: {error: loadError, success: false}, bubbles: true, cancelable: true});
         fireEvent(self.pageRef, eventTypes.PDF_LOADED, event);
     });*/
  }

  /**
   * 
   * @param {*} event 
   */
  toggleToolbar(event) {
    // ORV240123 added a new class showToolbar to display the toolbar by default and toogle accordingly
    let isToolbarShown = this.template.querySelector(".toolbarPane").classList.contains("showToolbar");
    if (isToolbarShown) {
      this.template.querySelector(".toolbarPane").classList.remove("showToolbar");
      this.template.querySelector(".toolbarPane").classList.add("hideToolbar");
    } else {
      this.template.querySelector(".toolbarPane").classList.remove("hideToolbar");
      this.template.querySelector(".toolbarPane").classList.add("showToolbar");
    }
  }
  /**
   * hide toolbar 
   */
  hideToolbar(event) {
    this.template.querySelector(".toolbarPane").classList.add("hideToolbar");
  }

  /**
   * show toolbar 
   */
  showToolbar(event) {
    this.template.querySelector(".toolbarPane").classList.remove("hideToolbar");
  }
  closeSidebarPanel() {
    //debugger;
    let sidebar = this.template.querySelector(".slds-panel");
    if (sidebar.className.indexOf(" slds-is-open")) {
      sidebar.className = sidebar.className.replace(" slds-is-open");
    }
  }

  /**
   * Close the defualt help contents, If it is in a modal. (AHS)
   */
  closeDefaultContentOnPDFLoad() {
    //debugger;
    this.template.querySelector(".default-content").classList.add("display-none");
  }

  /**
   * Close the defualt help contents, If it is in a modal. (AHS)
   */
  closeDefaultContent() {
    let classList = this.template.querySelector(".default-content").classList;
    if (classList.contains("display-none")) {
      classList.add("display-block"); // Hide the contents only if it is in a modal
    } else {
      classList.add("display-none");
    }
  }

  /**
   * Open the defualt help contents in a modal. (AHS)
   */
  openDefaultContent() {
    this.template.querySelector(".default-content").classList.add("modal");
    this.template.querySelector(".default-content").classList.remove("display-none");
  }
  get panelClasses() {
    let panelClasses = "thumbnail panel-content slds-panel slds-size_small slds-panel_docked slds-panel_docked-left slds-panel_drawer";
    // panelClasses += (!isMobile() && this.displayThumbnails) ? " slds-is-open" : "";
    panelClasses += this.displayThumbnails ? " slds-is-open" : ""; //ORV240212 remove "!isMobile()" check as thumnails are displayed on mobile and desktop ; changes requested by Eric
    panelClasses += isMobile() ? " mobile-thumbnail" : "";
    return panelClasses;
  }
  get toolbarClasses() {
    let toolbarPanelClasses = __g_defaultToolbar ? "toolbarPane" : "toolbarPane showToolbar";
    return toolbarPanelClasses;
  }
  handleToggleThumbnails(evt) {
    let action = evt.detail.action;
    let panel = this.template.querySelector(".slds-panel");
    console.log("action: " + action);
    console.log("panel: ", panel.className);
    console.log("panel: ", panel.classList);
    let isSidebarOpen = panel.classList.contains("slds-is-open");
    if (isSidebarOpen) {
      panel.classList.remove("slds-is-open");
    } else {
      panel.classList.add("slds-is-open");
    }
  }
  handleLoadPdf(evt) {
    console.log("loadingDefaultPdf : ", evt);
    this.loadingDefaultPdf = evt.detail.loadingDefaultPdf;
    this.defaultPdfUrl = evt.detail.defaultPdfUrl;
    this.pdfFile = evt.detail.file;
    this.fillOnLoad = evt.detail.fillOnLoad;
    this.selectedPersona = evt.detail.selectedPersona;
    this.initializeChildren();
  }
  connectedCallback() {
    this.isMobile = isMobile();
    //CRN230410 Make this component's template visible globally so that the toolbar can be programmatically hidden/shown.
    window.__g_MainWindowTemplate = this.template;
    if (window.location.hash.indexOf("#g=") > -1) {
      //ERS221027
      let gd = window.location.hash.substring(3);
      let tok = null;
      if (gd.indexOf("&") > -1) {
        let i = gd.indexOf("&");
        let j = window.location.hash.indexOf("t=");
        if (j > -1) {
          tok = window.location.hash.substring(j + 2);
          tok = tok.replace("&", ""); //ERS221116 TODO better arg parsing
        }
        gd = gd.substring(0, i); //TODO not be g={}&t={}& order dependent
      }
      //  loadPdfFromGoogle(gd,tok);
    }
    console.log("@@@@ pdfViewer connectedCallback");
    this.renderMobileToolbar = isMobile();
    console.log("isMobile : " + isMobile());
    console.log("isHorizontal : " + isHorizontal());
    //   setApp(this);  

    window.console.log("renderThumbnails => " + this.renderThumbnails);
    //debugger;
    // get user preferences (show thumbnails and/or toolbar?)
    // this.renderThumbnails = __g_showThumbnails;
    // this.toolbarType = __g_toolbarType;
    // console.log('@@@@ FormsView is added to DOM @@@@');
    // registerListener(eventTypes.SHOW_DE_PANEL, this.handleShowDEPanel, this);

    //ORV249827  register and display toolba only when tParam is not off 
    if (!isMobile() && this.tParam?.toLowerCase() != 'off') {
      this.displayToolbar = true;
      registerListener("initialize-zplib", this.callInitializeZpLib, this);
    }
    registerListener("initialize-markup", this.callInitializeMarkup, this);
    registerListener('pageChange', pageChangeEvent => {
      console.log("page change event invoked");
      console.log("queueRenderPage 2");
      let pdfViewerMainPane = this.template.querySelector("zpaper-pdf-viewer-main-pane");
      pdfViewerMainPane.queueRenderPage(pageChangeEvent.selectedPageNumber, 0);
    }, this);
    registerListener(eventTypes.TOGGLE_THUMBNAILS, this.handleToggleThumbnails, this);
    registerListener(eventTypes.LOAD_PDF, this.handleLoadPdf, this);
    registerListener(eventTypes.PDF_LOADED, this.closeDefaultContentOnPDFLoad, this); //AHS230316 - hide the default help when a pdf is passed to main pane / thumbnails using this event
    registerListener(eventTypes.LOCAL_FILE_UPLOAD, this.closeDefaultContentOnPDFLoad, this); //AHS230316 - hide the default help when a pdf is passed to main pane / thumbnails using this event
    registerListener(eventTypes.DISPLAY_HELP, this.openDefaultContent, this);
    registerListener(eventTypes.HIDE_HELP, this.closeDefaultContentOnPDFLoad, this);
    if (this.parentLoadsPdf && !window.noURLParameter) {
      this.initializeChildren();
    }
  }
  renderedCallback() {
    window.__g_MainContainerTemplate = this.template;
    if (!this.initialRenderDone) {
      //ORV240826 if fParam is present dont show help page
      const urlParams = new URLSearchParams(window.location.search);
      let fParam = urlParams.get('f');
      if (!fParam) {
        this.template.querySelector(".default-content").classList.remove("display-none");
        this.template.querySelector(".default-content").classList.add("display-block");
      }
      activateHelp('pdfMainPane', this.template);
      //AHS230928 - As mentioned by Eric we would need thumbnails on mobile (certain features like download will be dependent on them) - commented start
      //CRN230421 Don't show thumbnails in mobile.
      // this.renderThumbnails = this.displayThumbnails = false; 
      // if (!isMobile()) {
      //     if (__g_showThumbnails?.toLowerCase() === 'false') {
      //         this.renderThumbnails = true;
      //         this.displayThumbnails = false;
      //     } else if (__g_showThumbnails?.toLowerCase() === 'off') {
      //         this.renderThumbnails = false;
      //         this.displayThumbnails = false;
      //     } else {
      //         this.renderThumbnails = true;
      //         this.displayThumbnails = true;
      //     }
      // }
      //AHS230928 - As mentioned by Eric we would need thumbnails on mobile (certain features like download will be dependent on them) - commented end
      //AHS230928 - As mentioned by Eric we would need thumbnails on mobile (certain features like download will be dependent on them) - added start
      this.renderThumbnails = true; //always render thumbnails
      this.displayThumbnails = true; //hide them by default
      if (isMobile() && !__g_showThumbnails) {
        //ORV240304 default hide thumnails for mobile
        this.renderThumbnails = true;
        this.displayThumbnails = false;
      } else if (__g_showThumbnails?.toLowerCase() === 'false' || __g_showThumbnails?.toLowerCase() === 'off') {
        // || isMobile()
        this.renderThumbnails = true;
        this.displayThumbnails = false;
      }
      /*else if (__g_showThumbnails?.toLowerCase() === 'off') { //ORV240305 off should behave like false
          this.renderThumbnails = false;
          this.displayThumbnails = false;
      }*/

      //AHS230928 - As mentioned by Eric we would need thumbnails on mobile (certain features like download will be dependent on them) - added end
    }
    this.initialRenderDone = true;
  }
  disconnectedCallback() {
    unregisterAllListeners(this);
  }
  handleShowDEPanel(evt) {
    this.displayDEPanel = true;
  }

  //ahs - added start
  callInitializeZpLib(evt) {
    //console.log("callInitializeZpLib : " + JSON.stringify(evt));
    console.log("buttons:", evt.buttons);
    let pdfViewerToolbar = this.template.querySelector("zpaper-pdf-viewer-toolbar");
    let pdfViewerThumbnails = this.template.querySelector("zpaper-pdf-viewer-thumbnails");
    if (evt.loadBasicToolbar) {
      pdfViewerToolbar.initializeZpLib({
        pdfPage: evt.pdfPage,
        pdfPageOverlay: evt.pdfPageOverlay,
        buttons: evt.buttons,
        pdfInfo: evt.pdfInfo,
        pdfViewerMainPane: evt.pdfViewerMainPane,
        loadBasicToolbar: evt.loadBasicToolbar,
        loadingDefaultPdf: evt.loadingDefaultPdf,
        source: evt.source,
        sourceUrl: evt.sourceUrl
      });
    } else if (evt.nonPdfFile) {
      pdfViewerToolbar.initializeZpLib({
        nonPdfFile: evt.nonPdfFile
      });
      pdfViewerThumbnails.removeThumbnails(evt.nonPdfFile);
    } else if (evt.htmlFile) {
      pdfViewerToolbar.initializeZpLib({
        htmlFile: evt.htmlFile
      });
      pdfViewerThumbnails.removeThumbnails(evt.htmlFile);
    } else {
      pdfViewerToolbar.initializeZpLib({
        pdfPage: evt.pdfPage,
        pdfPageOverlay: evt.pdfPageOverlay,
        buttons: evt.buttons,
        pdfInfo: evt.pdfInfo,
        pdfViewerMainPane: evt.pdfViewerMainPane,
        loadingDefaultPdf: evt.loadingDefaultPdf,
        source: evt.source,
        sourceUrl: evt.sourceUrl
      });
    }
    console.log(evt.pdfViewerMainPane);
    console.log("callInitializeZpLib end");
    console.log($(evt.pdfViewerMainPaneTemplate));
    console.log(evt.pdfViewerMainPaneTemplate.querySelector(".pdfPage"));
  }
  callInitializeMarkup(evt) {
    console.log("callInitializeMarkup : " + JSON.stringify(evt));
    let pdfViewerToolbar = this.template.querySelector("zpaper-pdf-viewer-toolbar");
    //debugger;
    console.log("callInitializeMarkup2");
    pdfViewerToolbar.initializeMarkup({
      pdfPage: evt.canvas,
      pdfPageOverlay: evt.pdfPageOverlay
    });
    console.log("callInitializeMarkup end");
  }
  handleLeftSidebarClose() {
    closeSidebar("Left");
  }
  handleRightSidebarClose() {
    closeSidebar("Right");
  }
  //ahs - added end
}
_registerDecorators(pdfViewer, {
  publicProps: {
    parentLoadsPdf: {
      config: 0
    },
    tParam: {
      config: 0
    }
  },
  track: {
    displayDEPanel: 1,
    renderThumbnails: 1,
    toolbarType: 1
  },
  fields: ["displayThumbnails", "renderMobileToolbar", "showThumbnails", "displayToolbar", "pageRef", "loadingDefaultPdf", "defaultPdfUrl", "pdfFile", "fillOnLoad", "selectedPersona", "renderToolbarButton", "isMobile", "initialRenderDone"]
});
export default _registerComponent(pdfViewer, {
  tmpl: _tmpl
});